module.exports = __webpack_public_path__ + "img/ico_sea.565558e8.png";